import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { ReactComponent as Icon } from "../svg/pricing.svg";

export default function PricingIcon(props: SvgIconProps) {
  return <SvgIcon {...props} component={Icon} inheritViewBox fontSize="inherit" />;
}
